var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWithdrawnFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#FF824A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10.8906C17 14.7566 13.866 17.8906 9.99997 17.8906C6.13398 17.8906 2.99997 14.7566 2.99997 10.8906C2.99997 7.02463 6.13398 3.89062 9.99997 3.89062C13.866 3.89062 17 7.02463 17 10.8906ZM9.87026 7.05461C10.0558 7.2591 10.0405 7.57531 9.83602 7.76089L8.59114 8.89063H10.5893C12.0094 8.89063 13.2881 9.9096 13.2881 11.3134V11.4679C13.2881 12.8717 12.0094 13.8906 10.5893 13.8906H8.65131C8.37517 13.8906 8.15131 13.6668 8.15131 13.3906C8.15131 13.1145 8.37517 12.8906 8.65131 12.8906H10.5893C11.5899 12.8906 12.2881 12.1953 12.2881 11.4679V11.3134C12.2881 10.5859 11.5899 9.89063 10.5893 9.89063H8.59114L9.83602 11.0204C10.0405 11.2059 10.0558 11.5222 9.87026 11.7266C9.68468 11.9311 9.36847 11.9465 9.16398 11.7609L7.30814 10.0767L7.30812 10.0767C6.89728 9.70385 6.89731 9.0774 7.30812 8.70458L9.16398 7.02037C9.36847 6.83479 9.68468 6.85012 9.87026 7.05461Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdrawnFill);
export default __webpack_public_path__ + "static/media/icon-withdrawn-fill.76551adba812883ec65aee95277b163b.svg";
export { ForwardRef as ReactComponent };